import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Empty, EmptyHeader, EmptyTitle } from '@/components/ui/empty';
import {
  Item,
  ItemActions,
  ItemContent,
  ItemDescription,
  ItemGroup,
  ItemTitle,
} from '@/components/ui/item';
import { RechtenBadge } from './RechtenBadge';
import { useStuurUitnodigingOpnieuw, useTrekUitnodigingIn, useUitnodigingen } from './personen.api';

/**
 * De uitnodigingen die nog open staan.
 *
 * Hier stonden ook de rechtentabel en het antwoordadres. Allebei verhuisd naar
 * de instellingen: het ene is naslag en het andere een knop die je één keer
 * zet, en geen van beide gaat over uitnodigen. Wat overblijft is de lijst zelf.
 *
 * Uitnodigen zelf gebeurt niet hier maar bij de persoon: je nodigt iemand uit
 * die al in de app staat, met zijn rollen en zijn opdracht erbij. Een los
 * e-mailadres uitnodigen leverde een account op dat daarna alsnog helemaal moest
 * worden ingevuld.
 */
export function UitnodigingenTab() {
  const { data } = useUitnodigingen();
  const opnieuw = useStuurUitnodigingOpnieuw();
  const trekIn = useTrekUitnodigingIn();
  const openstaand = data?.uitnodigingen ?? [];

  return (
    <Card>
      <CardHeader>
        <CardTitle>Openstaand</CardTitle>
      </CardHeader>
      <CardContent>
        {openstaand.length === 0 ? (
          <Empty>
            <EmptyHeader>
              <EmptyTitle>Geen openstaande uitnodigingen.</EmptyTitle>
            </EmptyHeader>
          </Empty>
        ) : (
          <ItemGroup>
            {openstaand.map((u) => (
              <Item key={u.id} variant="muted">
                <ItemContent>
                  <ItemTitle>
                    {u.email ?? '—'}
                    <RechtenBadge rechten={u.rechten} />
                    {u.verlopen && <Badge variant="destructive">verlopen</Badge>}
                  </ItemTitle>
                  <ItemDescription>
                    {u.verlopen ? 'verliep' : 'verloopt'}{' '}
                    {new Date(u.expiresAt).toLocaleString('nl-NL', {
                      day: 'numeric',
                      month: 'long',
                      hour: '2-digit',
                      minute: '2-digit',
                    })}
                    {u.uitgenodigdDoor ? ` · door ${u.uitgenodigdDoor}` : ''}
                  </ItemDescription>
                </ItemContent>
                <ItemActions>
                  {/* Opnieuw sturen vervangt het token, dus de oude link werkt
                        daarna niet meer. Dat is de bedoeling: een link die blijft
                        rondzwerven is een tweede sleutel. */}
                  <Button
                    disabled={opnieuw.isPending}
                    onClick={() => opnieuw.mutate(u.id)}
                    size="sm"
                    variant="ghost"
                  >
                    {opnieuw.isPending ? 'Bezig…' : 'Opnieuw sturen'}
                  </Button>
                  <Button onClick={() => trekIn.mutate(u.id)} size="sm" variant="ghost">
                    Intrekken
                  </Button>
                </ItemActions>
              </Item>
            ))}
          </ItemGroup>
        )}
      </CardContent>
    </Card>
  );
}
